module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.7a1a54e.eot";